import { connect } from 'react-redux';
import { getKeywords, setKeywords } from '../../../modules/Filters';
import { getRefdata } from '../../../modules/Settings';
import KeywordInputGroup from './KeywordInputGroup';

const mapStateToProps = state => ({
  keywords: getKeywords(state),
  searchList: getRefdata(state)
});

const mapDispatchToProps = dispatch => ({
  changedKeywords: str => dispatch(setKeywords(str))
});

const KeywordInputGroupContainer = connect(mapStateToProps, mapDispatchToProps)(KeywordInputGroup);

export default KeywordInputGroupContainer;
